export const Colors = {
  baseColor: "#2a2f83",
  appColor: "#832b67",
};
